"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$articleGroupNum = void 0;
const factory_1 = __importDefault(require("../factory"));
const lexical_1 = require("./lexical");
exports.$articleGroupNum = factory_1.default
    .withName("articleGroupNum")
    .choice(c => c
    .or(r => r
    .sequence(c => c
    .and(r => r.seqEqual("第"))
    .and(() => lexical_1.$kanjiDigits)
    .and(r => r.regExp(/^[編章節款目]/), "typeChar")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(c => c
    .and(r => r.regExp(/^[のノ]/))
    .and(() => lexical_1.$kanjiDigits))))
    .action(({ text, typeChar }) => {
    return {
        value: {
            typeChar: typeChar,
            text: text(),
        },
        errors: [],
    };
})))
    .or(r => r
    .sequence(c => c
    .and(r => r.seqEqual("第"))
    .and(() => lexical_1.$arabicDigits)
    .and(r => r.regExp(/^[編章節款目]/), "typeChar")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(c => c
    .and(r => r.regExp(/^[のノ]/))
    .and(() => lexical_1.$arabicDigits))))
    .action(({ text, typeChar }) => {
    return {
        value: {
            typeChar: typeChar,
            text: text(),
        },
        errors: [],
    };
}))));
exports.default = exports.$articleGroupNum;
//# sourceMappingURL=$articleGroupNum.js.map